<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Valutazione ADL" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Abbigliamento e Aspetto igienico</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneAdl.abbigliamentoAspettoIgienico }}</span>
                        <b-form-select v-else v-model="jsonDataValutazioneAdl.abbigliamentoAspettoIgienico" :options="abbigliamentoAspettoIgienicoOptions" :disabled="isReadOnly">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Capacità cura autonoma</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneAdl.capacitaCuraAutonoma }}</span>
                        <b-form-select v-else v-model="jsonDataValutazioneAdl.capacitaCuraAutonoma" :options="capacitaCuraAutonomaOptions" :disabled="isReadOnly">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Supporto per attività quotidiane: </label>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-row>
                                <b-col cols="auto" v-for="adl in adlOptions" :key="'adl-' + adl.id" class="sa-switch-select-element">
                                    <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedAdl" :value="adl.voce" @change="onSelectCheckBox">
                                        <span style="font-weight: normal">{{ adl.voce }}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneAdl.note }}</span>
                        <b-form-textarea v-else v-model="jsonDataValutazioneAdl.note" :readonly="isReadOnly" max-rows="10" rows="7"> </b-form-textarea>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
        <!-- 
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Supporto per attività quotidiane: " header-tag="header" footer-tag="footer" title="">
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-row>
                        <b-col cols="auto" v-for="adl in adlOptions" :key="'adl-' + adl.id" class="sa-switch-select-element">
                            <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedAdl" :value="adl.voce">
                                <span style="font-weight: normal">{{ adl.voce }}</span>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </b-col>
            </b-card>
        </b-col> -->
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataValutazioneAdl: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    abbigliamentoAspettoIgienico: "",
                    capacitaCuraAutonoma: "",
                    note: "",
                    listaSchedaAdlDettaglio: [],
                };
            },
        },
    },
    mounted() {
        let me = this;
        me.loadDizionarioData();
        // console.log("MOUNTED DEL 4° LIVELLO, PRENDO OGGETTO NELLA PROPS: [4° LIVELLO] con il seguente jsonDataValutazioneAdl:", me.jsonDataValutazioneAdl);
    },
    watch: {
        jsonDataValutazioneAdl: {
            handler(jsonData) {
                this.$emit("update", jsonData);
                this.popolaArrayDaListe();
            },
            deep: true,
        },
    },

    mixins: [UtilityMixin],
    data() {
        return {
            pathResourceSchedaInfermieristicaValutazioneAdl: "/rsaschedainfermieristicavalutazioneadl",
            pathResourceDizionario: "/rsadizionario",
            adlOptions: [],
            selectedAdl: [],
            // jsonDataValutazioneAdl: {
            //     id: null,
            //     idAccettazione: null,
            //     abbigliamentoAspettoIgienico: null,
            //     capacitaCuraAutonoma: null,
            //     note: null,
            //     listaSchedaAdlDettaglio: [],
            // },

            abbigliamentoAspettoIgienicoOptions: [
                { text: "CURATO", value: "CURATO" },
                { text: "TRASANDATO", value: "TRASANDATO" },
            ],
            capacitaCuraAutonomaOptions: [
                { text: "AUTONOMO", value: "AUTONOMO" },
                { text: "SUPERVISIONE", value: "SUPERVISIONE" },
                { text: "DIPENDENTE", value: "DIPENDENTE" },
            ],
        };
    },
    methods: {
        popolaArrayDaListe() {
            let me = this;
            // console.log("STO INIZIANDO A FARE IL POPOLAMENTO NEL METODO popolaArrayList del [4° LIVELLO] con il seguente jsonDataValutazioneAdl:", this.jsonDataValutazioneAdl);
            me.selectedAdl = [];
            if (me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio.length > 0) {
                // console.log("SONO ALL'INTERNO DELLA CONDIZIONE IF DEL METODO popoLAarray del [4° LIVELLO], entro se ho: ", me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio);
                // console.log("me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio.length: ", me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio.length);
                me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio.forEach((item) => {
                    if (item.tipo === "ADL") {
                        me.selectedAdl.push(item.voce);
                    }
                });
            }
            // console.log("FINE POPOLAMENTO [4° LIVELLO], ADL DETTAGLIO: ", me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio);
        },
        onSelectCheckBox() {
            let me = this;
            let listaSchedaAdlDettaglio = [];
            // console.log("selectedAdl", me.selectedAdl);
            me.selectedAdl.forEach((voce) => {
                listaSchedaAdlDettaglio.push({
                    id: null,
                    idSchedaInfermieristicaValutazioneAdl: me.jsonDataValutazioneAdl.id,
                    tipo: "ADL",
                    voce: voce,
                });
            });
            me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio = listaSchedaAdlDettaglio;
        },
        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },

        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data?.data?.list) {
                me.adlOptions = response.data.data.list.filter((item) => item.tipo === "ADL");
            }
        },
        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento adl", error);
        },

        onSalvaValutazioneAdl() {
            let me = this;
            me.jsonDataValutazioneAdl.idAccettazione = me.idAccettazione;
            /* console.log("Salvataggio VALUTAZIONE ADL con dati:", JSON.stringify(me.jsonDataValutazioneAdl)); */
            if (!me.jsonDataValutazioneAdl.idAccettazione) {
                // console.log("idAccettazione: ", me.jsonDataValutazioneAdl.idAccettazione);
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            let listaSchedaAdlDettaglio = [];
            me.selectedAdl.forEach((voce) => {
                listaSchedaAdlDettaglio.push({
                    id: null,
                    idSchedaInfermieristicaValutazioneAdl: me.jsonDataValutazioneAdl.id,
                    tipo: "ADL",
                    voce: voce,
                });
            });
            me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio = listaSchedaAdlDettaglio;
            UtilityMixin.methods.saveResource(me.pathResourceSchedaInfermieristicaValutazioneAdl, me.jsonDataValutazioneAdl, me.saveValutazioneAdlSuccessResponse, me.saveValutazioneAdlErrorResponse);
        },
        saveValutazioneAdlSuccessResponse() {
            /* console.log("VALUTAZIONE ADL salvato con successo:", response); */
        },
        saveValutazioneAdlErrorResponse() {
            /* console.error("Errore nel salvataggio VALUTAZIONE ADL:", error); */
        },
        /* resetForm() {
            let me = this;
            me.jsonDataValutazioneAdl = {
                id: null,
                idAccettazione: me.idAccettazione,
                abbigliamentoAspettoIgienico: null,
                capacitaCuraAutonoma: null,
                note: null,
                listaSchedaAdlDettaglio: [],
            };

            me.selectedAdl = [];
        },


      /*   loadValutazioneAdlData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaInfermieristicaValutazioneAdl + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaInfermieristicaValutazioneAdlSuccess, me.resultResponseSchedaInfermieristicaValutazioneAdlError);
        },
        resultResponseSchedaInfermieristicaValutazioneAdlSuccess(response) {
            let me = this;
            Object.keys(response.data.data).forEach((key) => {
                me.jsonDataValutazioneAdl[key] = response.data.data[key];
            });
            let selectedAdl = [];
            me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio.forEach((item) => {
                if (item.tipo === "ADL") {
                    selectedAdl.push(item.voce);
                }
            });
            me.jsonDataValutazioneAdl.listaSchedaAdlDettaglio = selectedAdl;
        },
        resultResponseSchedaInfermieristicaValutazioneAdlError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                //console.log("NESSUN record trovato del VALUTAZIONE ADL per questo id accettazione");
                me.resetForm();
            } else {
                console.error("Errore nel caricamento dati della sezione VALUTAZIONE ADL:", error);
            }
        }, */
    },
};
</script>
